<script setup lang="ts">
import AppLayout from '@/components/app-layouts/AppLayout.vue';
import SessionManager from '@/components/session/SessionManager.vue';
import { Notivue, Notification, NotivueTheme, NotivueKeyboard } from 'notivue';
import { Config } from 'tailwindcss';
import { computed, inject } from 'vue';
import { useRoute } from 'vue-router';
import { configNVTheme } from '../notivue.config';
const theme: Config = inject('theme');
const nvTheme: NotivueTheme = configNVTheme(theme);

const route = useRoute();
// Client session policy (idle warning/logout, reactive token refresh, cross-tab
// sync) applies only to authenticated app routes — never the public
// report-render route or the pre-auth pages (callback/signup/verify), which
// have no user session to manage.
const isSessionManaged = computed(() => route.meta.requiresAuth !== false && !route.meta.isPublic);
</script>

<template>
  <SessionManager v-if="isSessionManaged" />
  <NotivueKeyboard v-slot="{ containersTabIndex }">
    <Notivue v-slot="item" :class="{ CenterOnMobile: true }" :containers-tab-index="containersTabIndex">
      <Notification :item="item" :theme="nvTheme" />
    </Notivue>
  </NotivueKeyboard>
  <AppLayout />
</template>
